import {PageTemplate} from "../../shared/layout/PageTemplate";
import {LocationContent} from "./components/LocationContent";

export function Location() {
    return <PageTemplate pageName="Location" title="Enum" content={<LocationContent/>}/>
}